import I18n from 'I18n';
import { PortalsAppLayout } from 'portals-platform-lib';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { BuyerLogoSection } from '../components/Header/BuyerLogoSection';
import { DealPlanName } from '../components/DealPlanName';
import { DealPlanPortalTable } from '../components/DealPlanPortalTable';
import { AvatarsProvider } from '../contexts/AvatarsContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Preview() {
  return /*#__PURE__*/_jsx(AvatarsProvider, {
    data: null,
    children: /*#__PURE__*/_jsx(PortalsAppLayout, {
      headerStart: /*#__PURE__*/_jsx(BuyerLogoSection, {
        isHubSpotUser: false,
        dealPlanId: 0
      }),
      children: /*#__PURE__*/_jsx(Flex, {
        flex: "1",
        minBlockSize: "0",
        blockSize: "100%",
        alignItems: "stretch",
        children: /*#__PURE__*/_jsx(View, {
          flex: "1",
          minInlineSize: "0",
          overflow: "auto",
          paddingInline: "600",
          paddingBlock: "400",
          paddingBlockStart: "900",
          children: /*#__PURE__*/_jsxs(View, {
            maxInlineSize: "900px",
            marginInlineStart: "auto",
            marginInlineEnd: "auto",
            children: [/*#__PURE__*/_jsx(DealPlanName, {
              name: I18n.text('dealPlan.previewName'),
              dealPlanId: 0
            }), /*#__PURE__*/_jsx(DealPlanPortalTable, {
              dealPlanId: 0,
              milestones: [],
              isLoading: true
            })]
          })
        })
      })
    })
  });
}